'use client';

import { FC, useEffect } from 'react';

import { getUserGroupId } from '@/general/components/Analytics/Analytics.helpers';
import { carmaAsciiInConsole } from '@/general/helpers/carmaAscii';
import { pushToDataLayer } from '@/utils/pushToDataLayer';

export const WebsiteGlobals: FC = () => {
  useEffect(() => {
    carmaAsciiInConsole();

    const userGroup = getUserGroupId();

    pushToDataLayer({
      event: 'app_init',
      userGroup,
    });
  }, []);

  return null;
};
